import mapData from "lib/stores/mapData";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import { colorScales, colorRanges } from "lib/data/colorScales";

const normalisedPrevalence = 0.1;
const normalisedVulnerability = 0.1;
const normalisedGov = 0.1;

const storedColors = {
  prevalence: new Map(),
  vulnerability: new Map(),
  "gov-response": new Map()
};

export default function getPolyFillColor() {
  switch (mapData.activeCategory) {
    case "prevalence":
      return info => {
        return prevalenceDefaultColor(info);
      };
    case "vulnerability":
      return (info, object) => {
        return vulnerabilityDefaultColor(info);
      };
    case "gov-response":
      return info => {
        return govresponseDefaultColor(info);
      };
    default:
      return;
  }
}

const colorFromRange = (ranges, value, hmm = false) => {
  const rangeStart = Math.floor(value * 10);
  return ranges[rangeStart](value).coords;
};

const prevalenceDefaultColor = info => {
  try {
    const country = apiData.countries[info.properties.ISO_A3];
    if (!Math.abs(country[mapData.year].prevalence)) {
      return [217, 217, 217];
    }
    if (country[mapData.year].prevalence < 0) {
      const [r, g, b] = colorFromRange(colorRanges.prevalenceRanges, 0);
      return [255 * r, 255 * g, 255 * b];
    }
    const normalisedPrevalence = country[mapData.year].prevalence > 16 ? 1 : country[mapData.year].prevalence / 16;
    if (normalisedPrevalence === 0) return [217, 217, 217];
    const [r, g, b] = colorFromRange(colorRanges.prevalenceRanges, normalisedPrevalence);
    return [255 * r, 255 * g, 255 * b];
  } catch (error) {
    return [217, 217, 217];
  }
};

const vulnerabilityDefaultColor = info => {
  try {
    const country = apiData.countries[info.properties.ISO_A3];
    if (!Math.abs(country[mapData.year].vulnerability)) {
      return [217, 217, 217];
    }
    if (country[mapData.year].vulnerability < 0) {
      const [r, g, b] = colorFromRange(colorRanges.vulnerabilityRanges, 0);
      return [255 * r, 255 * g, 255 * b];
    }
    const normalisedVulnerability = country[mapData.year].vulnerability / 100;
    if (normalisedVulnerability === 0) return [217, 217, 217];
    if (info.properties.ISO_A3 === "TCD") {
      const [r, g, b] = colorFromRange(colorRanges.vulnerabilityRanges, normalisedVulnerability, true);
      return [255 * r, 255 * g, 255 * b];
    } else {
      const [r, g, b] = colorFromRange(colorRanges.vulnerabilityRanges, normalisedVulnerability);
      return [255 * r, 255 * g, 255 * b];
    }
  } catch (error) {
    return [217, 217, 217];
  }
};

const govresponseDefaultColor = info => {
  try {
    const country = apiData.countries[info.properties.ISO_A3];
    if (!Math.abs(country[mapData.year].govresponse)) {
      return [217, 217, 217];
    }
    if (country[mapData.year].govresponse < 0) {
      const [r, g, b] = colorFromRange(colorRanges.govresponseRanges, 0);
      return [255 * r, 255 * g, 255 * b];
    }
    const normalisedGov = country[mapData.year].govresponse / 100;
    if (normalisedGov === 0) return [217, 217, 217];
    const [r, g, b] = colorFromRange(colorRanges.govresponseRanges, normalisedGov);
    return [255 * r, 255 * g, 255 * b];
  } catch (error) {
    return [217, 217, 217];
  }
};
